const setHeaderHeight = () => {
	const init = () => {
		const root = document.documentElement,
			siteHeader = document.querySelector( '.site-header' );

		root.style.setProperty(
			'--header-height',
			`${ siteHeader.getBoundingClientRect().height }px`
		);
	};

	return {
		init,
	};
};

export default setHeaderHeight;
